import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayMessageIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22 2.25H2C1.04 2.25 0.25 3.04 0.25 4V20C0.25 20.96 1.04 21.75 2 21.75H22C22.96 21.75 23.75 20.96 23.75 20V4C23.75 3.04 22.96 2.25 22 2.25ZM22.25 17L16.12 11.57L22.25 6.77V17ZM2 3.75H22C22.14 3.75 22.25 3.86 22.25 4V5.18L12 13.2L1.75 5.18V4C1.75 3.86 1.86 3.75 2 3.75ZM7.88 11.57L1.75 17V6.77L7.88 11.57ZM22 20.25H2C1.86 20.25 1.75 20.14 1.75 20V18.67L8.88 12.35L11.62 14.49C11.85 14.67 12.16 14.67 12.39 14.49L15.12 12.35L22.25 18.67V20C22.25 20.14 22.14 20.25 22 20.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayMessageIcon.displayName = 'PayMessageIcon';
